import { MainLayout } from '@/components/layout/MainLayout';
import { EditorContainer } from '@/components/editor/EditorContainer';
import { FormattingPanel } from '@/components/formatting/FormattingPanel';
import { QuickFormatButtons } from '@/components/formatting/QuickFormatButtons';
import { ContentStats } from '@/components/stats/ContentStats';
import { StylePresets } from '@/components/formatting/StylePresets';
import { EmojiPicker } from '@/components/formatting/EmojiPicker';
import { Toast } from '@/components/ui/toast';
import { useUIStore } from '@/stores/uiStore';

export default function App() {
  const theme = useUIStore((s) => s.theme);
  return (
    <div className={theme === 'dark' ? 'dark' : ''}>
      <MainLayout>
        <div className="container mx-auto container-max px-4 py-6 grid md:grid-cols-3 gap-6">
          <div className="md:col-span-2 space-y-6">
            <EditorContainer />
            <FormattingPanel />
          </div>
          <div className="space-y-6">
            <QuickFormatButtons />
            <ContentStats />
            <StylePresets />
          </div>
        </div>
      </MainLayout>
      <EmojiPicker />
      <Toast />
    </div>
  );
}
